import React, { forwardRef } from 'react'
import CheckboxField from './CheckboxField'
import ComboBoxField from './ComboBoxField'
import DateField from './DateField'
import FieldGroup from './FieldGroup'
import InputField from './InputField'
import LookupField from './LookupField'
import RadioField from './RadioField'
import RadioGroupField from './RadioGroupField'
import SelectField from './SelectField'

/**
 * @template T
 * @template P
 * @param {React.ForwardRefRenderFunction<T, P>} Component
 * @returns {React.ForwardRefExoticComponent<P>}
 */
function showIconInError (Component) {
  const InnerComponent = ({ innerRef, ...props }) => {
    const errorOptions = Object.assign(
      { showIconInError: true },
      props.errorOptions || {}
    )
    return <Component {...props} ref={innerRef} errorOptions={errorOptions} />
  }

  return forwardRef((props, ref) => (
    <InnerComponent innerRef={ref} {...props} />
  ))
}

export default {
  CheckboxField: showIconInError(CheckboxField),
  ComboBoxField: showIconInError(ComboBoxField),
  DateField: showIconInError(DateField),
  FieldGroup: showIconInError(FieldGroup),
  InputField: showIconInError(InputField),
  LookupField: showIconInError(LookupField),
  RadioField: showIconInError(RadioField),
  RadioGroupField: showIconInError(RadioGroupField),
  SelectField: showIconInError(SelectField)
}
